import { useState, useRef, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [marketplaceOpen, setMarketplaceOpen] = useState(false);
  const marketplaceRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (marketplaceRef.current && !marketplaceRef.current.contains(e.target)) {
        setMarketplaceOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const closeAll = () => {
    setMarketplaceOpen(false);
  };

  return (
    <div className="header-wrapper position-absolute w-100" style={{ top: 0, left: 0, zIndex: 100 }}>
      <Container>
        <Navbar expand="lg" className={`header-navbar${menuOpen ? ' expanded-mobile' : ''}`} onToggle={(expanded) => setMenuOpen(expanded)}>
          {/* Logo */}
          <Navbar.Brand as={NavLink} to="/" className="me-4">
            <img
              src="/assets/images/logo.webp"
              alt="Azamra Logo"
              className="header-logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" className="header-toggle">
            <img src="/assets/images/hamburger.webp" alt="Menu" className="header-hamburger-icon" />
          </Navbar.Toggle>

          <Navbar.Collapse id="main-navbar">
            {/* Nav Links */}
            <Nav className="me-auto ms-2">
              <Nav.Link as={NavLink} to="/" className="header-nav-link" end>
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/about-us" className="header-nav-link">
                About Us
              </Nav.Link>
              <Nav.Link as={NavLink} to="/treasury-solutions" className="header-nav-link">
                Treasury Solutions
              </Nav.Link>
              <Nav.Link as={NavLink} to="/investment-solution" className="header-nav-link">
                Investment Solutions
              </Nav.Link>

              {/* Marketplace dropdown (Marketplace, Azamra Homes) */}
              <div className="header-dropdown-wrapper" ref={marketplaceRef}>
                <button
                  className="header-nav-link header-dropdown-trigger"
                  onClick={() => setMarketplaceOpen((prev) => !prev)}
                >
                  Marketplace
                  <svg
                    className={`header-dropdown-arrow${marketplaceOpen ? ' open' : ''}`}
                    width="12" height="12" viewBox="0 0 12 12" fill="none"
                  >
                    <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                {marketplaceOpen && (
                  <div className="header-dropdown-menu">
                    <NavLink to="/marketplace" className="header-dropdown-item" onClick={closeAll}>
                      Marketplace
                    </NavLink>

                    <img src="/divider.webp" alt="" className="header-dropdown-divider" />

                    <NavLink to="/marketplace/azamra-homes" className="header-dropdown-item" onClick={closeAll}>
                      Azamra Homes
                    </NavLink>
                  </div>
                )}
              </div>

              <Nav.Link as={NavLink} to="/contact" className="header-nav-link">
                Contact Us
              </Nav.Link>
            </Nav>

            {/* Download Button */}
            <Button className="header-download-btn">
              Download App
            </Button>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
};

export default Header;
